/**
 * PHARMAKON — className merge utility
 *
 * Ported from the design's lib/cn.js. The design's implementation was a
 * hand-rolled concatenator (strings/arrays/objects). We use clsx + tailwind-merge
 * here (the standard shadcn convention picked in scope answer #4) so that
 * downstream class overrides on shadcn-based primitives correctly dedupe
 * conflicting Tailwind utilities. The accepted argument shapes (string,
 * array, conditional object) are a superset of the design's contract.
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(...inputs));
}

export default cn;
